<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Position Keeping</h5>
                  <h2 class=" card-title"><i class="fas fa-redo-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Exposure & Rebalancing</h2>
                </div>
                <div class=" col-sm-6">
                  <div class="btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedRebalanceTab=='exposure'}"
                           (click)="selectedRebalanceTab='exposure';rebalancingTab='factorExposure'">Exposure</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedRebalanceTab=='weights'}"
                           (click)="selectedRebalanceTab='weights'">Weights</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedRebalanceTab=='rebalance'}"
                           (click)="selectedRebalanceTab='rebalance'">Rebalance</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedRebalanceTab=='rebalance'">
                <div class="row">
                  <div class="col-12 text-center text-primary"><h2>Do you want to rebalance your portfolio at the end of this quarter?</h2></div>
                  <div class="col-12 text-center mt-3">Rebalancing will be applied in {{ nextRebalancingDate | date:'MMMM d, y' }}</div>
                  <div class="offset-3 col-4 mt-5" style="line-height: 30px">
                    <mat-checkbox class="example-margin" [(ngModel)]="rebalanceYes" (change)="checkRebalanceYes()">Rebalance portfolio</mat-checkbox>
                  </div>
                  <div class="col-4 mt-5" style="line-height: 30px">
                    <mat-checkbox class="example-margin" [(ngModel)]="rebalanceNo" (change)="checkRebalanceNo()">Do not rebalance</mat-checkbox>
                  </div>
                </div>
              </div>
              <div *ngIf="selectedRebalanceTab=='exposure'">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <!-- Exposure Tables -->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onRebalancingTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab label="Exposure"></mat-tab>
                  <mat-tab label="Spread"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Factor Exposure table -->
                <table id="tableToExport" *ngIf="rebalancingTab=='factorExposure' && investableRA" mdbTable small="true">
                  <thead>
                    <tr>
                      <th scope="col" width="30%">Beta</th>
                      <th *ngFor="let cat of quarterly_dates" scope="col" >{{ cat }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="investableRA.quarterly_exposure.size">
                      <th scope="row">Size</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.size[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.value">
                      <th scope="row">Value</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.value[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.momentum">
                      <th scope="row">Momentum</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.momentum[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.volatility">
                      <th scope="row">Volatility</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.high_yield">
                      <th scope="row">High Yield</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.high_yield[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.quality">
                      <th scope="row">Quality</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.quality[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_exposure.factor_intensity">
                      <th scope="row">Factor Intensity</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_exposure.factor_intensity[cat] | percent:'.1' }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Factor Exposure table -->

                <!-- Factor Monitoring table -->
                <table id="tableToExport" *ngIf="rebalancingTab=='factorMonitoring' && investableRA" mdbTable small="true">
                  <thead>
                    <tr>
                      <th scope="col" width="30%">Beta spread</th>
                      <th *ngFor="let cat of quarterly_dates" scope="col" >{{ cat }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="investableRA.quarterly_spread.size">
                      <th scope="row">Size</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.size[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.value">
                      <th scope="row">Value</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.value[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.momentum">
                      <th scope="row">Momentum</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.momentum[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.volatility">
                      <th scope="row">Volatility</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.high_yield">
                      <th scope="row">High Yield</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.high_yield[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.quality">
                      <th scope="row">Quality</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.quality[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investableRA.quarterly_spread.factor_intensity">
                      <th scope="row">Factor Intensity</th>
                      <td *ngFor="let cat of quarterly_dates">{{ investableRA.quarterly_spread.factor_intensity[cat] | percent:'.1' }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Factor Monitoring table -->
                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                  </em>
                </div>
                <!-- Exposure Tables -->
              </div>
              <div *ngIf="selectedRebalanceTab=='weights'">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <!-- Portfolio Monitoring table -->
                <table id="tableToExport" *ngIf="investableRA" mdbTable small="true">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th *ngFor="let cat of quarterly_dates" scope="col" style="width:90px">{{ cat }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let label of completenessLabels">
                      <th class="ellipsis" scope="row">
                        <span mdbTooltip="{{ completenessNames[label] }}">{{ completenessNames[label] }}</span>
                      </th>
                      <td *ngFor="let cat of quarterly_dates" scope="col" style="width:90px">{{ investableRA.quarterly_weights[label][cat] | percent:'.1' }}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- Portfolio Monitoring table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ investmentDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                  </em>
                </div>
              </div>
            </div>
            <div *ngIf="selectedRebalanceTab=='rebalance'" class=" card-footer">
              <div class="row">
                <div class="col-12 text-center">
                  <app-button *ngIf="rebalanceYes" (click)="onRebalance()">Rebalance</app-button>
                  <app-button *ngIf="rebalanceNo" (click)="onDoNotRebalance()">Do not Rebalance</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <br>
  </div>
</div>
